import React, { Component } from 'react';
import 'CSS/App.css';

import { BrowserRouter as Router,
  Route,
  NavLink
} from 'react-router-dom'

import Home from "Components/site/pages/Home"
import Work from "Components/site/pages/Work"
import Tools from "Components/site/pages/Tools"
import LoginForm from "Components/util/LoginForm"
import LogoutConfirmation from "Components/util/LogoutConfirmation"

class App extends Component {
    state = {
        authenticated: false
    }
  render() {
    return (
<Router>
<div>
    <header>
        <div className="header_container">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/work/">Work</NavLink>
            {
                // this.state.authenticated === true
                false && (<NavLink to="/tools/">Tools</NavLink>)
            }
            <a target="blank" href="https://blue-collar-dev.perhinschi.com/">↪Notes</a>
        </div>
    </header>
    <Route exact path="/" component={Home}/>
    <Route path="/work" component={Work}/>
    <Route path="/tools" component={Tools}/>
    {/* <Route path="/login" component={LoginForm}/>
    <Route path="/logout" component={LogoutConfirmation}/> */}
    <footer>
    <div className="footer_container">
    <p>&copy; Emil Nicolaie Perhinschi</p>
    </div>
    </footer>
</div>
</Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/lib/App.js